import { handleResponse, handleError } from "./apiUtils";
//const baseUrl = process.env.API_URL + "/events/";
const baseUrl = process.env.REACT_APP_API_SERVER_URL + "/api/event";
const token =
  "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI0TXRsajBqRG5mTWdkZXNPdmtEZzF0In0.hhGRbAH57nedbJ6cJ1pLNC9F2FcigHVWfWIr0PiTs-_0h1Cduy2kfp0Bvh8LOcC_lSnjTSpADdKdntoUv7S-8VpbUaMGIYX5Csgq9uH9oY6yMLd0Z-hUPrFAbNN-9BKk79Tre2Gwkfm8TIUP3SvBh3Uw-OUaZ4IJxLm-bRruPb2wT6VXIGLqn8opQ4AZ21lS88O5lQFC-rv5holy2Htv6uNtpCX6QWHqiJUjYtGzWaBMKaflCXFefwncI8JhBXt3y3SGUM6CnG5HW5JDXWgNKLPAD_0M0cnlQmcOiguxinS9WfLbeB5EK4cLSmVtzfGb0pkpmLCkG8asSf_c78c1Vg";

export function getAllEvents() {
  const vv = "Malmö";
  const dd = new Date().toLocaleString().substring(0, 10);
  console.log(baseUrl + `?city=${vv}&date=${dd}`);
  return fetch(baseUrl, { headers: { Authorization: "Bearer " + token } })
    .then(handleResponse)
    .catch(handleError);
}

export function getEvents(date, city) {
  console.log("get all");
  let thisUrl = baseUrl;
  if (date) {
    thisUrl += "?date=" + date;
    if (city) {
      thisUrl += "&city=" + city;
    }
  } else if (city) {
    thisUrl += "?city=" + city;
  }

  return fetch(thisUrl, { headers: { Authorization: "Bearer " + token } })
    .then(handleResponse)
    .catch(handleError);
}

export function getAttending(accessToken) {
  return fetch(baseUrl + `/attending`, {
    headers: { Authorization: "Bearer " + accessToken }
  })
    .then(handleResponse)
    .catch(handleError);
}

//Will probably not use in the future
export function getAttendingEventsThisWeek(accessToken) {
  return fetch(baseUrl + `/attendingThisWeek`, {
    headers: { Authorization: "Bearer " + accessToken }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function getEvent(id) {
  console.log("get one with id: ", id);
  return fetch(baseUrl + "?id=" + id, {
    headers: { Authorization: "Bearer " + token }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function saveEvent(accessToken, event) {
  return fetch(baseUrl, {
    method: event.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(event)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function addSiblings(accessToken, siblings) {
  return fetch(baseUrl + "/siblings", {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify(siblings)
  })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteEvent(accessToken, id) {
  return fetch(baseUrl + "?id=" + id, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + accessToken
    }
  })
    .then(handleResponse)
    .catch(handleError);
}

export function signUp(accessToken, event) {
  console.log(event.id);
  return fetch(baseUrl + "/signup", {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify({ eventid: event.id })
  })
    .then(handleResponse)
    .catch(handleError);
}

export function unSignUp(accessToken, event) {
  console.log(event.id);
  return fetch(baseUrl + "/unsignup", {
    method: "PUT",
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + accessToken
    },
    body: JSON.stringify({ eventid: event.id })
  })
    .then(handleResponse)
    .catch(handleError);
}
